import { useCallback } from 'react';

import { defineMessages, useIntl } from 'react-intl';

import { useDispatch } from 'react-redux';

import MoreHorizIcon from '@/material-icons/400-24px/more_horiz.svg?react';
import BookmarksIcon from '@/material-icons/400-24px/bookmarks.svg?react';
import BlockIcon from '@/material-icons/400-24px/block.svg?react';
import DomainDisabledIcon from '@/material-icons/400-24px/domain_disabled.svg?react';
import EditNoteIcon from '@/material-icons/400-24px/edit_note.svg?react';
import FilterAltIcon from '@/material-icons/400-24px/filter_alt.svg?react';
import ListAltIcon from '@/material-icons/400-24px/list_alt.svg?react';
import LogoutIcon from '@/material-icons/400-24px/logout.svg?react';
import PersonAddIcon from '@/material-icons/400-24px/person_add.svg?react';
import PushPinIcon from '@/material-icons/400-24px/push_pin.svg?react';
import SettingsIcon from '@/material-icons/400-24px/settings.svg?react';
import StarIcon from '@/material-icons/400-24px/star.svg?react';
import VolumeOffIcon from '@/material-icons/400-24px/volume_off.svg?react';
import { openModal } from 'flavours/glitch/actions/modal';
import DropdownMenuContainer from 'flavours/glitch/containers/dropdown_menu_container';

const messages = defineMessages({
  edit_profile: { id: 'account.edit_profile', defaultMessage: 'Edit profile' },
  pins: { id: 'navigation_bar.pins', defaultMessage: 'Pinned posts' },
  preferences: { id: 'navigation_bar.preferences', defaultMessage: 'Preferences' },
  follow_requests: { id: 'navigation_bar.follow_requests', defaultMessage: 'Follow requests' },
  favourites: { id: 'navigation_bar.favourites', defaultMessage: 'Favorites' },
  lists: { id: 'navigation_bar.lists', defaultMessage: 'Lists' },
  followed_tags: { id: 'navigation_bar.followed_tags', defaultMessage: 'Followed hashtags' },
  blocks: { id: 'navigation_bar.blocks', defaultMessage: 'Blocked users' },
  domain_blocks: { id: 'navigation_bar.domain_blocks', defaultMessage: 'Blocked domains' },
  mutes: { id: 'navigation_bar.mutes', defaultMessage: 'Muted users' },
  filters: { id: 'navigation_bar.filters', defaultMessage: 'Muted words' },
  logout: { id: 'navigation_bar.logout', defaultMessage: 'Logout' },
  bookmarks: { id: 'navigation_bar.bookmarks', defaultMessage: 'Bookmarks' },
});

export const ActionBar = () => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const handleLogoutClick = useCallback(() => {
    dispatch(openModal({ modalType: 'CONFIRM_LOG_OUT' }));
  }, [dispatch]);

  let menu = [];

  menu.push({ text: intl.formatMessage(messages.edit_profile), href: '/settings/profile', icon: 'edit', iconComponent: EditNoteIcon });
  menu.push({ text: intl.formatMessage(messages.preferences), href: '/settings/preferences', icon: 'cog', iconComponent: SettingsIcon });
  menu.push({ text: intl.formatMessage(messages.pins), to: '/pinned', icon: 'thumb-tack', iconComponent: PushPinIcon });
  menu.push(null);
  menu.push({ text: intl.formatMessage(messages.follow_requests), to: '/follow_requests', icon: 'user-plus', iconComponent: PersonAddIcon });
  menu.push({ text: intl.formatMessage(messages.favourites), to: '/favourites', icon: 'star', iconComponent: StarIcon });
  menu.push({ text: intl.formatMessage(messages.bookmarks), to: '/bookmarks', icon: 'bookmarks', iconComponent: BookmarksIcon });
  menu.push({ text: intl.formatMessage(messages.lists), to: '/lists', icon: 'list-ul', iconComponent: ListAltIcon });
  menu.push({ text: intl.formatMessage(messages.followed_tags), to: '/followed_tags', icon: 'hashtag', iconComponent: FilterAltIcon });
  menu.push(null);
  menu.push({ text: intl.formatMessage(messages.mutes), to: '/mutes', icon: 'volume-off', iconComponent: VolumeOffIcon });
  menu.push({ text: intl.formatMessage(messages.blocks), to: '/blocks', icon: 'ban', iconComponent: BlockIcon });
  menu.push({ text: intl.formatMessage(messages.domain_blocks), to: '/domain_blocks', icon: 'ban', iconComponent: DomainDisabledIcon });
  menu.push({ text: intl.formatMessage(messages.filters), href: '/filters', icon: 'filter', iconComponent: FilterAltIcon });
  menu.push(null);
  menu.push({ text: intl.formatMessage(messages.logout), action: handleLogoutClick, icon: 'sign-out', iconComponent: LogoutIcon });

  return (
    <DropdownMenuContainer
      items={menu}
      icon='bars'
      iconComponent={MoreHorizIcon}
      size={24}
      direction='right'
    />
  );
};
